export const moneyFormat = number => {
  const res = new Intl.NumberFormat('fil-PH', {
    style: 'currency',
    currency: 'PHP'
  }).format(number);

  return res === '₱NaN' ? '₱0.00' : res;
};
